var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.saving ? _c('div', {
    staticClass: "absolute w-14 h-14 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white flex items-center justify-center"
  }, [_c('span', {
    staticClass: "h-6 w-6 spinner spinner-save"
  })]) : _c('div', {
    staticClass: "absolute w-14 h-14 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white flex items-center justify-center",
    on: {
      "click": function ($event) {
        return _vm.$emit('save');
      }
    }
  }, [_c('icon', {
    staticClass: "h-6 w-6",
    attrs: {
      "name": "save"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }